module.exports = __webpack_public_path__ + "img/SUBARU.82ed965.jpg";